"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactSpring = require("react-spring");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var InboxZero = function InboxZero(_ref) {
  var src = _ref.src,
    srcs = _ref.srcs,
    refresh = _ref.refresh;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    srcSet = _useState2[0],
    setSrcs = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    forceRefresh = _useState4[0],
    setForceRefresh = _useState4[1];
  var transitions = (0, _reactSpring.useTransition)(src, null, {
    from: {
      opacity: 0,
      zIndex: -1
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    },
    onRest: function onRest(item, status, props) {
      // Only set the `srcSet` when the animation is completed
      if (props.opacity === 1 && srcs.length) {
        setSrcs(srcs);
      }
    }
  });
  var shadowTransitions = (0, _reactSpring.useTransition)(forceRefresh, null, {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    },
    config: {
      duration: 500
    }
  });
  (0, _react.useEffect)(function () {
    setForceRefresh(!forceRefresh);
  }, [refresh]);
  (0, _react.useEffect)(function () {
    setSrcs([]);
  }, [src]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col w-full h-full text-white relative",
    style: {
      zIndex: 0
    }
  }, transitions.map(function (_ref2) {
    var item = _ref2.item,
      props = _ref2.props,
      key = _ref2.key;
    return /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
      key: key,
      style: props,
      className: "w-full h-full absolute inset-0"
    }, /*#__PURE__*/_react["default"].createElement("picture", {
      className: "relative w-full h-full"
    }, srcSet.map(function (_ref3) {
      var width = _ref3.width,
        src = _ref3.src;
      return /*#__PURE__*/_react["default"].createElement("source", {
        key: width,
        srcSet: src,
        media: "(min-width: ".concat(width, "px)")
      });
    }), /*#__PURE__*/_react["default"].createElement("img", {
      src: item,
      alt: "Inbox Zero",
      className: "w-full h-full object-cover"
    })));
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute inset-0 w-full h-full",
    style: {
      zIndex: 1
    }
  }, shadowTransitions.map(function (_ref4) {
    var props = _ref4.props,
      key = _ref4.key;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: key
    }, /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
      className: "absolute left-0 h-full",
      style: _objectSpread(_objectSpread({}, props), {}, {
        width: '25vw',
        background: 'linear-gradient(to right, black, rgba(0,0,0,0))'
      })
    }), /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
      className: "absolute top-0 w-full",
      style: _objectSpread(_objectSpread({}, props), {}, {
        height: 200,
        background: 'linear-gradient(to bottom, rgba(0,0,0, 0.8), rgba(0,0,0,0))'
      })
    }));
  })));
};
var _default = exports["default"] = InboxZero;
//# sourceMappingURL=index.js.map